import "bootstrap/dist/css/bootstrap.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";

import "./styles/MainTheme.scss";
import ThemeManager from "./ThemeManager";
import store from "./redux/store";

import { OpenAPI } from "./api/core/OpenAPI";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

if (process.env.NODE_ENV === "development") {
  OpenAPI.BASE = "http://localhost:7011";
}

root.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      {/* <Provider store={store}> */}
      <ThemeManager>
        <App />
      </ThemeManager>
      {/* </Provider>  */}
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
